/**
 * Generated bundle index. Do not edit.
 */

export * from './adapter-data-service-odata';
